import { render } from "./Image.vue?vue&type=template&id=153e07ae&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=153e07ae&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153e07ae"]])

export default __exports__